import { useEffect, useState } from 'react'
import { useDataChange } from 'Simple/Data.js'
import { RECORDER_STATES } from '../../../../helpers.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  // https://github.com/djkepa/custom-react-hooks/blob/main/packages/use-media-devices/src/index.tsx
  let [state, setState] = useState(data)
  let changeRecorderState = useDataChange({
    context: 'recorder',
    path: 'state',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (
      typeof navigator === 'undefined' ||
      typeof navigator.mediaDevices === 'undefined'
    ) {
      setState(s => ({ ...s, error: 'Media devices are not available' }))
      return
    }

    async function handleDeviceChange() {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true,
        })

        let devices = await navigator.mediaDevices.enumerateDevices()
        setState(s => ({
          ...s,
          devices: devices
            .filter(item => item.kind === 'audioinput')
            .map(device => ({
              id: device.deviceId,
              text: device.label || 'Unknown Device',
            })),
          loading: false,
          error: null,
        }))
      } catch (error) {
        changeRecorderState(RECORDER_STATES.ERROR)
        setState(s => ({
          ...s,
          loading: false,
          error: 'Unable to enumerate devices',
        }))
      }
    }

    setState(s => ({ ...s, loading: true }))
    handleDeviceChange()

    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange)

    return () => {
      navigator.mediaDevices.removeEventListener(
        'devicechange',
        handleDeviceChange
      )
    }
  }, [])

  return state
}
